import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { AgGridReact } from "ag-grid-react";
import axios from "axios";
import CountUp from "react-countup";
import { Fetchexecutequery } from "../../../services/process/BRS1/brsService7";

const Styles = () => (
  <style>{`
    @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700;800;900&display=swap');
    *, *::before, *::after { box-sizing:border-box; margin:0; padding:0; }

    .aw {
      --teal:  #2cc9d6;  --teal2: #1aabb8;
      --org:   #f4742b;  --grn:   #22c98a;
      --red:   #e05252;  --yel:   #f5c518;
      --dark:  #2e3a45;  --dark2: #3b4f60;
      --bg:    #eef2f7;  --card:  #ffffff;
      --muted: #8fa3b8;  --border:#dde8f0;
      --panel: #dde6f0;
      --sh:  0 2px 14px rgba(40,70,100,0.09);
      --sh2: 0 6px 26px rgba(40,70,100,0.16);
      background:var(--bg); font-family:'Poppins',sans-serif;
      color:var(--dark); min-height:100vh; padding:18px 22px 30px;
    }

    /* ── HEADER ── */
    .hdr { display:flex; align-items:center; justify-content:space-between; margin-bottom:18px; }
    .hdr h1 { font-size:22px; font-weight:700; }
    .hdr h1 span { color:var(--teal); }
    .hdr-btns { display:flex; gap:10px; }
    .hbtn { padding:8px 20px; border-radius:9px; font-size:13px; font-weight:600; border:none; cursor:pointer; font-family:'Poppins',sans-serif; transition:all .15s; }
    .hbtn-g { background:#d8e4ef; color:var(--dark2); } .hbtn-g:hover { background:#c8d8e8; }
    .hbtn-o { background:var(--org); color:#fff; }      .hbtn-o:hover { opacity:.88; }

    /* ══ ROW 1: grey panel + stat panel side by side, equal height ══ */
    .row1 {
      display: grid;
      grid-template-columns: 1fr 310px;
      gap: 16px;
      margin-bottom: 16px;
    }

    /* Grey wrapper — stretch to fill full row height */
    .kpi-wrap {
      background: var(--panel);
      border-radius: 22px;
      padding: 16px;
      display: flex;
      flex-direction: column;
      gap: 12px;
    }
    .kpi-cards-row {
      display: grid;
      grid-template-columns: repeat(6, 1fr);
      gap: 12px;
    }
    /* Agg strip inside grey panel */
    .kpi-agg-row {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 10px;
    }

    /* Every KPI card: white, uniform, centered */
    .kc {
      background: var(--card);
      border-radius: 16px;
      padding: 22px 12px 18px;
      display: flex; flex-direction:column; align-items:center; text-align:center;
      cursor:pointer; box-shadow:var(--sh);
      transition:transform .15s, box-shadow .15s;
      border:2px solid transparent;
    }
    .kc:hover { transform:translateY(-3px); box-shadow:var(--sh2); border-color:var(--teal); background:#fff; }

    /* Circular icon */
    .kc-ico {
      width:58px; height:58px; border-radius:50%;
      background:var(--panel);
      display:flex; align-items:center; justify-content:center;
      font-size:24px; margin-bottom:12px; flex-shrink:0;
    }
    .kc-lbl {
      font-size:10px; font-weight:700; text-transform:uppercase;
      letter-spacing:.7px; color:var(--muted); margin-bottom:6px; line-height:1.3;
    }
    .kc-val {
      font-size:26px; font-weight:900; line-height:1;
      color:var(--dark); margin-bottom:5px;
    }
    .kc-sub { font-size:11px; font-weight:600; color:var(--teal); }

    /* Stat panel — same height as kpi-wrap via grid stretch */
    .stat-panel {
      background:var(--card); border-radius:20px;
      padding:20px; box-shadow:var(--sh);
      display:flex; flex-direction:column;
    }
    .sp-radio { display:flex; gap:18px; margin-bottom:10px; }
    .sp-ropt  { display:flex; align-items:center; gap:6px; font-size:12px; font-weight:600; color:var(--muted); cursor:pointer; }
    .sp-dot   { width:13px; height:13px; border-radius:50%; border:2px solid var(--muted); flex-shrink:0; }
    .sp-dot.on{ background:var(--teal); border-color:var(--teal); }
    .sp-big   { font-size:48px; font-weight:900; color:var(--teal); line-height:1; margin-bottom:4px; }
    .sp-desc  { font-size:13px; font-weight:500; color:var(--dark2); margin-bottom:14px; line-height:1.5; }
    .sp-kv    { display:flex; justify-content:space-between; padding:5px 0; border-bottom:1px solid var(--border); }
    .sp-kv:last-of-type { border-bottom:none; margin-bottom:0; }
    .sp-k     { font-size:11px; color:var(--muted); }
    .sp-v     { font-size:11px; font-weight:700; color:var(--dark); }
    .sp-v.g   { color:var(--grn); }  .sp-v.t { color:var(--teal); }
    .sp-chart { margin-top:auto; padding-top:10px; }

    /* ══ AGG STRIP ══ */
    .agg-row { display:grid; grid-template-columns:repeat(4,1fr); gap:14px; margin-bottom:16px; }
    .agg {
      background:var(--card); border-radius:18px; padding:18px 20px;
      box-shadow:var(--sh); cursor:pointer;
      transition:transform .15s, box-shadow .15s;
      display:flex; flex-direction:column; gap:5px;
    }
    .agg:hover { transform:translateY(-3px); box-shadow:var(--sh2); }
    .agg-top  { display:flex; align-items:center; justify-content:space-between; margin-bottom:4px; }
    .agg-ico  { width:38px; height:38px; border-radius:12px; display:flex; align-items:center; justify-content:center; font-size:17px; }
    .agg-pill { font-size:9.5px; font-weight:700; padding:3px 10px; border-radius:20px; text-transform:uppercase; letter-spacing:.5px; }
    .agg-lbl  { font-size:10px; font-weight:700; text-transform:uppercase; letter-spacing:.8px; color:var(--muted); }
    .agg-val  { font-size:28px; font-weight:900; line-height:1; }
    .agg-sub  { font-size:11px; color:var(--muted); font-weight:500; }

    /* ══ ROW 2 ══ */
    .row2 { display:grid; grid-template-columns:1fr 210px 1fr; gap:16px; margin-bottom:16px; }
    .panel { background:var(--card); border-radius:20px; padding:20px; box-shadow:var(--sh); }

    .narr { font-size:13px; font-weight:500; color:var(--dark2); margin-bottom:14px; line-height:2.1; display:flex; flex-wrap:wrap; align-items:center; gap:5px; }
    .ntag  { background:var(--teal); color:#fff; border-radius:7px; padding:1px 9px; font-weight:700; font-size:12px; }
    .npct  { color:var(--teal); font-weight:800; font-size:16px; }
    .nbold { font-weight:800; color:var(--dark); }
    .nred  { color:var(--red); font-weight:700; }
    .norg  { color:var(--org); font-weight:700; }
    .ngrn  { color:var(--grn); font-weight:700; }

    .flbl  { display:flex; align-items:center; gap:8px; font-size:13px; font-weight:700; color:var(--dark2); margin-bottom:12px; }
    .fdot  { width:11px; height:11px; border-radius:50%; background:var(--org); flex-shrink:0; }
    .fbtns { display:flex; flex-direction:column; gap:8px; }
    .fbtn  { background:var(--teal); color:#fff; border:none; border-radius:10px; padding:11px 8px; font-size:12px; font-weight:700; cursor:pointer; font-family:'Poppins',sans-serif; transition:all .15s; text-align:center; }
    .fbtn:hover { opacity:.85; }
    .fbtn.off { background:#dde8f0; color:var(--dark2); }
    .dh    { font-size:13px; font-weight:500; color:var(--dark2); margin-bottom:12px; line-height:1.8; display:flex; flex-wrap:wrap; align-items:center; gap:5px; }

    /* ══ ROW 3 ══ */
    .row3 { display:grid; grid-template-columns:260px 1fr 1fr; gap:16px; }
    .donut-stat { background:var(--card); border-radius:20px; padding:20px; box-shadow:var(--sh); display:flex; flex-direction:column; align-items:center; text-align:center; gap:4px; }
    .ds-lbl { font-size:10px; font-weight:700; text-transform:uppercase; letter-spacing:.8px; color:var(--muted); }
    .ds-pct { font-size:42px; font-weight:900; color:var(--teal); line-height:1; }
    .ds-desc{ font-size:12px; font-weight:500; color:var(--dark2); }

    .qt-title { font-size:14px; font-weight:700; color:var(--dark2); margin-bottom:12px; }
    .qt-title span { color:var(--teal); font-weight:800; }
    .qt-grid  { display:grid; grid-template-columns:repeat(4,1fr); gap:10px; }
    .qt-card  { border-radius:16px; padding:16px 10px 12px; display:flex; flex-direction:column; align-items:center; text-align:center; cursor:pointer; transition:transform .15s; }
    .qt-card:hover { transform:translateY(-3px); }
    .qt-ico   { font-size:22px; margin-bottom:8px; }
    .qt-val   { font-size:15px; font-weight:900; color:#fff; line-height:1; margin-bottom:3px; }
    .qt-lbl   { font-size:9.5px; font-weight:600; color:rgba(255,255,255,.75); margin-bottom:10px; }
    .qt-badge { width:32px; height:32px; border-radius:50%; background:rgba(255,255,255,.22); display:flex; align-items:center; justify-content:center; font-size:9.5px; font-weight:800; color:#fff; }

    .dg-lbl  { display:flex; align-items:center; gap:8px; font-size:13px; font-weight:700; color:var(--dark2); margin-bottom:12px; }
    .dg-grid { display:grid; grid-template-columns:1fr 1fr; gap:9px; }
    .dg-btn  { background:var(--teal); color:#fff; border:none; border-radius:12px; padding:18px 10px; font-family:'Poppins',sans-serif; cursor:pointer; transition:all .15s; text-align:center; }
    .dg-btn:hover { opacity:.85; transform:scale(1.02); }
    .dg-num  { font-size:20px; font-weight:800; line-height:1; }
    .dg-name { font-size:10px; font-weight:600; opacity:.8; margin-top:3px; }
    .dg-amt  { font-size:11px; font-weight:700; color:rgba(255,255,255,.75); margin-top:6px; }

    /* ══ POPUP ══ */
    .pop-ov  { position:fixed;inset:0;background:rgba(30,50,70,.5);backdrop-filter:blur(7px);z-index:999;display:flex;align-items:center;justify-content:center; }
    .pop-box { background:var(--card);border-radius:22px;width:90vw;max-width:1100px;max-height:82vh;overflow:hidden;display:flex;flex-direction:column;box-shadow:0 24px 64px rgba(30,60,90,.22); }
    .pop-hd  { display:flex;align-items:center;justify-content:space-between;padding:16px 22px;border-bottom:1px solid var(--border);background:var(--bg); }
    .pop-ttl { font-size:18px;font-weight:800;color:var(--dark); }
    .pop-cl  { background:var(--dark);color:#fff;border:none;padding:8px 18px;border-radius:9px;font-size:13px;font-weight:700;cursor:pointer;font-family:'Poppins',sans-serif; }
    .pop-cl:hover { background:var(--teal2); }
    .pop-bd  { padding:18px;flex:1;overflow:hidden; }
  `}</style>
);

export default function DashboardComponent() {
  const [kpi, setKpi]           = useState({});
  const [invCards, setInvCards] = useState([]);
  const [poChart, setPoChart]   = useState({ series:[], labels:[] });
  const [invChart, setInvChart] = useState({ series:[], labels:[] });
  const [tableData, setTableData] = useState([]);
  const [popup, setPopup]       = useState({ open:false, title:"" });
  const [activeFilter, setFilter] = useState(null);
  const [statMode, setStatMode]   = useState("value"); // "value" | "count" 
  const cache = {};

  const db = async q => {
    if (cache[q]) return cache[q];
    const cr = Fetchexecutequery();
    const r  = await axios.post(cr[1], { query:q }, cr[0]);
    cache[q] = r.data; return r.data;
  };

  useEffect(() => { Promise.all([loadKpis(), loadPo(), loadInv()]); }, []);

  const loadKpis = async () => setKpi((await db(`SELECT
    (SELECT COUNT(*) FROM bct_ap_poc.po_header) total_po,
    (SELECT COUNT(*) FROM bct_ap_poc.po_header WHERE status='Open') open_po,
    (SELECT COUNT(*) FROM bct_ap_poc.po_header WHERE status='Closed') closed_po,
    (SELECT COUNT(*) FROM bct_ap_poc.po_header WHERE status='Partial Receipt') partial_po,
    (SELECT COUNT(*) FROM bct_ap_poc.grp_details) total_grp,
    (SELECT COUNT(*) FROM bct_ap_poc.inv_field) total_inv,
    (SELECT COUNT(*) FROM bct_ap_poc.inv_field WHERE status='Open') open_inv,
    (SELECT COUNT(*) FROM bct_ap_poc.inv_field WHERE status='Sent for Payment') ready_pay,
    (SELECT IFNULL(SUM(po_total),0) FROM bct_ap_poc.po_header) po_val,
    (SELECT IFNULL(SUM(po_total),0) FROM bct_ap_poc.po_header WHERE status='Open') open_po_val,
    (SELECT IFNULL(SUM(po_total),0) FROM bct_ap_poc.po_header WHERE status='Closed') closed_po_val,
    (SELECT IFNULL(SUM(po_total),0) FROM bct_ap_poc.po_header WHERE status='Partial Receipt') partial_po_val,
    (SELECT IFNULL(SUM(invoice_total),0) FROM bct_ap_poc.inv_field) inv_val,
    (SELECT IFNULL(SUM(invoice_total),0) FROM bct_ap_poc.inv_field WHERE status='Open') open_inv_val,
    (SELECT IFNULL(SUM(invoice_total),0) FROM bct_ap_poc.inv_field WHERE status='Sent for Payment') ready_val`))[0]);

  const loadPo  = async () => { const r = await db(`SELECT status,COUNT(*) total FROM bct_ap_poc.po_header GROUP BY status`); setPoChart({series:r.map(x=>+x.total),labels:r.map(x=>x.status)}); };
  const loadInv = async () => {
    const r = await db(`SELECT status,COUNT(*) total,IFNULL(SUM(invoice_total),0) value FROM bct_ap_poc.inv_field GROUP BY status`);
    setInvChart({series:r.map(x=>+x.total),labels:r.map(x=>x.status)});
    setInvCards(r);
  };

  const drill = async (tbl, status, title) => {
    let q = `SELECT * FROM bct_ap_poc.${tbl}`;
    if (status !== "ALL") q += ` WHERE status='${status}'`;
    setTableData(await db(q));
    setPopup({ open:true, title });
  };

  const usd  = n => new Intl.NumberFormat("en-US",{style:"currency",currency:"USD",notation:"compact",maximumFractionDigits:1}).format(n||0);
  const usdF = n => new Intl.NumberFormat("en-US",{style:"currency",currency:"USD"}).format(n||0);
  const fmt  = n => new Intl.NumberFormat("en-IN").format(n||0);
  const pct  = (a,b) => b ? ((+a/+b)*100).toFixed(1) : "0.0";

  const tPo=+kpi.total_po||0,  cPo=+kpi.closed_po||0,  pPo=+kpi.partial_po||0, oPo=+kpi.open_po||0;
  const tInv=+kpi.total_inv||0, oInv=+kpi.open_inv||0, rPay=+kpi.ready_pay||0, tGrp=+kpi.total_grp||0;
  const poVal=+kpi.po_val||0,   invVal=+kpi.inv_val||0, oInvV=+kpi.open_inv_val||0, rVal=+kpi.ready_val||0;
  const cPoV=+kpi.closed_po_val||0, pPoV=+kpi.partial_po_val||0, oPoV=+kpi.open_po_val||0;

  const spendUtil = pct(invVal, poVal);
  const closeRate = pct(cPo, tPo);
  const clearRate = pct(rPay, tInv);
  const grpCov    = pct(Math.min(tGrp,tPo), tPo);
  const liabPct   = pct(oInvV, invVal);
  // Unique CFO metric: unmatched spend = PO value not yet invoiced
  const uninvoiced = Math.max(0, poVal - invVal);
  // PO aging proxy: partial+open as % of total
  const poAtRisk   = pct(oPo + pPo, tPo);

  /* ── 6 KPI cards in 3x2 grid — all truly distinct CFO metrics ── */
  const kpiCards = [
    { lbl:"Total PO",       val:fmt(tPo),    sub:usd(poVal),                   ico:"📄", st:"ALL",              tbl:"po_header"   },
    { lbl:"Open PO",        val:fmt(oPo),    sub:usd(oPoV),                    ico:"📂", st:"Open",             tbl:"po_header"   },
    { lbl:"Partial PO",     val:fmt(pPo),    sub:usd(pPoV),                    ico:"⚡", st:"Partial Receipt",  tbl:"po_header"   },
    { lbl:"Closed PO",      val:fmt(cPo),    sub:usd(cPoV),                    ico:"✅", st:"Closed",           tbl:"po_header"   },
    { lbl:"Total Invoices", val:fmt(tInv),   sub:usd(invVal),                  ico:"🧾", st:"ALL",              tbl:"inv_field"   },
    { lbl:"Total GRP",      val:fmt(tGrp),   sub:"GRP records",                ico:"📦", st:"ALL",              tbl:"grp_details" },
  ];

  /* ── 4 CFO aggregate ratio cards ── */
  const aggCards = [
    { lbl:"Spend Utilisation",   val:`${spendUtil}%`, sub:`Invoiced ${usd(invVal)} of ${usd(poVal)} committed`,      ico:"📊", bg:"#eaf8fa", valClr:"#2cc9d6", icoClr:"#2cc9d6", pill:"EFFICIENCY", pillBg:"#cef3f6", pillClr:"#1aabb8", onClick:()=>drill("po_header","ALL","All POs")           },
    { lbl:"PO Closure Rate",     val:`${closeRate}%`, sub:`${fmt(cPo)} closed · ${fmt(pPo)} partial · ${fmt(oPo)} open`, ico:"✅", bg:"#eafaf3", valClr:"#22c98a", icoClr:"#22c98a", pill:"HEALTH",     pillBg:"#cbf5e4", pillClr:"#16a870", onClick:()=>drill("po_header","Closed","Closed POs")      },
    { lbl:"Invoice Clear Rate",  val:`${clearRate}%`, sub:`${fmt(rPay)} cleared of ${fmt(tInv)} total invoices`,     ico:"💰", bg:"#fff8ec", valClr:"#f4742b", icoClr:"#f4742b", pill:"CLEARED",    pillBg:"#fde8d0", pillClr:"#c85a10", onClick:()=>drill("inv_field","Sent for Payment","Payment Queue") },
    { lbl:"PO At-Risk Rate",     val:`${poAtRisk}%`,  sub:`${fmt(oPo+pPo)} open/partial of ${fmt(tPo)} total POs`,  ico:"🔴", bg:"#fff3f3", valClr:"#e05252", icoClr:"#e05252", pill:"AT RISK",    pillBg:"#fddede", pillClr:"#c03030", onClick:()=>drill("po_header","Open","Open POs")           },
  ];

  /* ── Quarterly breakdown cards ── */
  const qtCards = [
    { lbl:"Open PO",   val:usd(oPoV), badge:pct(oPo,tPo),  color:"#2e3a45", ico:"📂", st:"Open",             tbl:"po_header" },
    { lbl:"Partial PO",val:usd(pPoV), badge:pct(pPo,tPo),  color:"#f5c518", ico:"⚡", st:"Partial Receipt",  tbl:"po_header" },
    { lbl:"Closed PO", val:usd(cPoV), badge:pct(cPo,tPo),  color:"#22c98a", ico:"✅", st:"Closed",           tbl:"po_header" },
    { lbl:"Ready Pay INV", val:usd(rVal), badge:clearRate,      color:"#f4742b", ico:"💳", st:"Sent for Payment", tbl:"inv_field" },
  ];

  /* ── Chart configs ── */
  const donutCfg = (ch, tbl) => ({
    labels:ch.labels,
    colors:["#2cc9d6","#2e3a45","#f4742b","#f5c518","#22c98a","#a78bfa"],
    legend:{ position:"bottom", labels:{colors:"#8fa3b8"}, fontSize:"11px", fontFamily:"Poppins" },
    plotOptions:{ pie:{ donut:{ size:"64%", labels:{ show:true, total:{ show:true, label:"Total", color:"#8fa3b8", fontSize:"11px", fontFamily:"Poppins", fontWeight:700 }}}}},
    chart:{ background:"transparent", events:{ dataPointSelection:(_,__,c)=>drill(tbl,ch.labels[c.dataPointIndex],ch.labels[c.dataPointIndex]) }},
    dataLabels:{ style:{ fontSize:"10px", fontFamily:"Poppins", colors:["#fff"] }, dropShadow:{ enabled:true, blur:2, opacity:0.5 }},
    stroke:{ width:2, colors:["#fff"] }, tooltip:{ theme:"light" },
  });

  const barCfg = {
    chart:{ type:"bar", background:"transparent", toolbar:{show:false} },
    colors:["#2cc9d6","#22c98a","#2e3a45","#f4742b"],
    plotOptions:{ bar:{ borderRadius:6, columnWidth:"55%", distributed:true }},
    dataLabels:{ enabled:true, formatter:v=>usd(v), style:{ fontSize:"9.5px", colors:["#3b4f60"], fontFamily:"Poppins" }, offsetY:-16 },
    xaxis:{ categories:invCards.map(x=>x.status), labels:{ style:{ fontSize:"10px", fontFamily:"Poppins", colors:"#8fa3b8" }, rotate:-10 }},
    yaxis:{ labels:{ formatter:v=>usd(v), style:{ fontSize:"9px", fontFamily:"Poppins" }}},
    legend:{ show:false }, grid:{ borderColor:"#e8f0f8" }, tooltip:{ theme:"light" },
  };

  const poBarCfg = {
    chart:{ type:"bar", background:"transparent", toolbar:{show:false} },
    colors:["#2cc9d6"],
    plotOptions:{ bar:{ borderRadius:5, columnWidth:"58%" }},
    dataLabels:{ enabled:true, formatter:v=>usd(v), style:{ fontSize:"9px", colors:["#3b4f60"], fontFamily:"Poppins" }, offsetY:-14 },
    xaxis:{ categories:poChart.labels, labels:{ style:{ fontSize:"9px", fontFamily:"Poppins", colors:"#8fa3b8" }}},
    yaxis:{ labels:{ formatter:v=>usd(v), style:{ fontSize:"9px", fontFamily:"Poppins" }}},
    grid:{ borderColor:"#e8f0f8" }, tooltip:{ theme:"light" },
  };

  const colDefs = Object.keys(tableData[0]||{}).map(k=>({headerName:k,field:k,flex:1}));

  return (
    <>
      <Styles />
      <div className="aw">

        {/* ── HEADER ── */}
        <div className="hdr">
          <h1><span>AP&nbsp;</span>Reconciliation Dashboard</h1>
          <div className="hdr-btns">
            <button className="hbtn hbtn-g" onClick={()=>drill("po_header","ALL","All POs")}>PO View</button>
            <button className="hbtn hbtn-g" onClick={()=>drill("grp_details","ALL","All GRP")}>GRP View</button>
            {/* <button className="hbtn hbtn-o" onClick={()=>setFilter(null)}>Clear Filters</button> */}
          </div>
        </div>

        {/* ══ ROW 1: 3×2 KPI grid + stat panel ══ */}
        <div className="row1">

          {/* 6 uniform white KPI cards in 3 columns × 2 rows */}
          <div className="kpi-wrap">
            {/* 6 KPI cards — single row */}
            <div className="kpi-cards-row">
              {kpiCards.map(c => (
                <div key={c.lbl} className="kc" onClick={()=>drill(c.tbl, c.st, c.lbl)}>
                  <div className="kc-ico">{c.ico}</div>
                  <div className="kc-lbl">{c.lbl}</div>
                  <div className="kc-val">{c.val}</div>
                  <div className="kc-sub">{c.sub}</div>
                </div>
              ))}
            </div>
            {/* Agg strip fills the space below — inside grey panel */}
            <div className="kpi-agg-row">
              {aggCards.map(a => (
                <div key={a.lbl} className="agg" style={{background:a.bg}} onClick={a.onClick}>
                  <div className="agg-top">
                    <div className="agg-ico" style={{background:`${a.icoClr}25`}}>{a.ico}</div>
                    <div className="agg-pill" style={{background:a.pillBg,color:a.pillClr}}>{a.pill}</div>
                  </div>
                  <div className="agg-lbl">{a.lbl}</div>
                  <div className="agg-val" style={{color:a.valClr}}>{a.val}</div>
                  <div className="agg-sub">{a.sub}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Stat panel */}
          <div className="stat-panel">
            <div className="sp-radio">
              <div className="sp-ropt" onClick={()=>setStatMode("value")}><div className={`sp-dot ${statMode==="value"?"on":""}`}/>Value</div>
              <div className="sp-ropt" onClick={()=>setStatMode("count")}><div className={`sp-dot ${statMode==="count"?"on":""}`}/>Count</div>
            </div>
            <div className="sp-big">{statMode==="value" ? spendUtil+"%" : fmt(tPo)}</div>
            <div className="sp-desc">
              {statMode==="value"
                ? <span>Spend utilisation<br/><b style={{color:"#2e3a45"}}>Invoiced vs PO Commitment</b></span>
                : <span>Total Purchase Orders<br/><b style={{color:"#2e3a45"}}>Count Overview</b></span>}
            </div>
            {statMode==="value" ? <>
              <div className="sp-kv"><span className="sp-k">Total Invoice Value</span><span className="sp-v">{usd(invVal)}</span></div>
              <div className="sp-kv"><span className="sp-k">Total PO Value</span><span className="sp-v">{usd(poVal)}</span></div>
              <div className="sp-kv"><span className="sp-k">PO Closure Rate</span><span className="sp-v g">{closeRate}%</span></div>
              <div className="sp-kv"><span className="sp-k">Invoice Clear Rate</span><span className="sp-v t">{clearRate}%</span></div>
              <div className="sp-kv"><span className="sp-k">GRP Coverage</span><span className="sp-v t">{grpCov}%</span></div>
              <div className="sp-kv"><span className="sp-k">Uninvoiced Spend</span><span className="sp-v">{usd(uninvoiced)}</span></div>
            </> : <>
              <div className="sp-kv"><span className="sp-k">Total POs</span><span className="sp-v">{fmt(tPo)}</span></div>
              <div className="sp-kv"><span className="sp-k">Open POs</span><span className="sp-v" style={{color:"#f4742b"}}>{fmt(oPo)}</span></div>
              <div className="sp-kv"><span className="sp-k">Partial POs</span><span className="sp-v" style={{color:"#f5c518"}}>{fmt(pPo)}</span></div>
              <div className="sp-kv"><span className="sp-k">Closed POs</span><span className="sp-v g">{fmt(cPo)}</span></div>
              <div className="sp-kv"><span className="sp-k">Total Invoices</span><span className="sp-v">{fmt(tInv)}</span></div>
              <div className="sp-kv"><span className="sp-k">Ready for Payment</span><span className="sp-v t">{fmt(rPay)}</span></div>
            </>}
            <div className="sp-chart">
              {poChart.series.length > 0 && (
                <ReactApexChart type="bar" height={120}
                  series={[{ name:"PO Value", data:poChart.labels.map(l=>({Open:oPoV,Closed:cPoV,"Partial Receipt":pPoV}[l]||0)) }]}
                  options={poBarCfg}
                />
              )}
            </div>
          </div>
        </div>



        {/* ══ ROW 2 ══ */}
        <div className="row2">

          {/* Narrative + bar */}
          <div className="panel">
            <div className="narr">
              <span>Out of</span>
              <span className="ntag">{fmt(tPo)} POs</span>
              <span>worth</span><span className="nbold">{usd(poVal)}</span>
              <span>—</span>
              <span className="ngrn">{fmt(cPo)} Closed</span>
              <span>·</span>
              <span className="norg">{fmt(pPo)} Partial</span>
              <span>·</span>
              <span className="nred">{usd(uninvoiced)} still uninvoiced</span>
            </div>
            {invCards.length > 0 && (
              <ReactApexChart type="bar" height={205}
                series={[{ name:"Invoice Value", data:invCards.map(x=>+x.value) }]}
                options={barCfg}
              />
            )}
          </div>

          {/* PO Health Summary — replaces redundant invoice status filter */}
          <div className="panel">
            <div className="flbl"><div className="fdot" style={{background:"#2cc9d6"}}/>PO Health</div>
            <div style={{display:"flex",flexDirection:"column",gap:"8px"}}>
              {[
                { lbl:"Closed",  val:fmt(cPo),  amt:usd(cPoV), clr:"#22c98a", bg:"#eafaf3", st:"Closed"           },
                { lbl:"Partial", val:fmt(pPo),  amt:usd(pPoV), clr:"#f5c518", bg:"#fefae8", st:"Partial Receipt",   },
                { lbl:"Open",    val:fmt(oPo),  amt:usd(oPoV), clr:"#e05252", bg:"#fff3f3", st:"Open"              },
                { lbl:"GRP",     val:fmt(tGrp), amt:grpCov+"%", clr:"#2cc9d6", bg:"#eaf8fa", st:"ALL_GRP"          },
              ].map(r=>(
                <div key={r.lbl} onClick={()=>r.st==="ALL_GRP"?drill("grp_details","ALL","GRP Records"):drill("po_header",r.st,r.lbl+" POs")}
                  style={{background:r.bg,borderRadius:"10px",padding:"10px 12px",cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                  <div>
                    <div style={{fontSize:"10px",fontWeight:700,textTransform:"uppercase",letterSpacing:".5px",color:"#8fa3b8"}}>{r.lbl}</div>
                    <div style={{fontSize:"18px",fontWeight:900,color:r.clr,lineHeight:1}}>{r.val}</div>
                  </div>
                  <div style={{fontSize:"11px",fontWeight:700,color:r.clr,textAlign:"right"}}>{r.amt}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Donut + % headline */}
          <div className="panel">
            <div className="dh">
              <span className="npct">{clearRate}%</span>
              <span>of invoices are</span>
              <span className="nbold">Ready for Payment</span>
            </div>
            {invChart.series.length > 0 && (
              <ReactApexChart type="donut" height={235}
                series={invChart.series}
                options={donutCfg(invChart,"inv_field")}
              />
            )}
          </div>
        </div>

        {/* ══ ROW 3 ══ */}
        <div className="row3">

          {/* PO donut */}
          <div className="donut-stat">
            <div className="ds-lbl">PO Closure Rate</div>
            <div className="ds-pct">{closeRate}%</div>
            <div className="ds-desc">of Total POs Closed</div>
            {poChart.series.length > 0 && (
              <ReactApexChart type="donut" height={192}
                series={poChart.series}
                options={donutCfg(poChart,"po_header")}
              />
            )}
          </div>

          {/* Quarterly breakdown */}
          <div className="panel">
            <div className="qt-title">PO & Payment — <span>Value Breakdown</span></div>
            <div className="qt-grid">
              {qtCards.map(q => (
                <div key={q.lbl} className="qt-card" style={{background:q.color}}
                  onClick={()=>drill(q.tbl,q.st,q.lbl)}>
                  <div className="qt-ico">{q.ico}</div>
                  <div className="qt-val">{q.val}</div>
                  <div className="qt-lbl">{q.lbl}</div>
                  <div className="qt-badge">{q.badge}%</div>
                </div>
              ))}
            </div>
          </div>

          {/* Invoice status drill */}
          <div className="panel">
            <div className="dg-lbl"><div className="fdot"/>Drill Down by Invoice Status</div>
            <div className="dg-grid">
              {invCards.map(item => (
                <div key={item.status} className="dg-btn"
                  onClick={()=>drill("inv_field",item.status,item.status)}>
                  <div className="dg-num">{fmt(item.total)}</div>
                  <div className="dg-name">{item.status}</div>
                  <div className="dg-amt">{usdF(item.value)}</div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* ══ POPUP ══ */}
        {popup.open && (
          <div className="pop-ov" onClick={e=>{if(e.target===e.currentTarget)setPopup({open:false,title:""})}}>
            <div className="pop-box">
              <div className="pop-hd">
                <div className="pop-ttl">{popup.title}</div>
                <button className="pop-cl" onClick={()=>setPopup({open:false,title:""})}>✕ Close</button>
              </div>
              <div className="pop-bd">
                <div className="ag-theme-alpine" style={{height:430}}>
                  <AgGridReact rowData={tableData} columnDefs={colDefs}
                    defaultColDef={{sortable:true,filter:true,resizable:true}}/>
                </div>
              </div>
            </div>
          </div>
        )}

      </div>
    </>
  );
}